import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

interface SustainabilityGaugeProps {
  data: {
    zero_waste_score: number;
    carbon_footprint: number;
    water_usage: number;
    total_records: number;
  };
  loading?: boolean;
}

const SustainabilityGauge: React.FC<SustainabilityGaugeProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-400">
        Loading sustainability data...
      </div>
    );
  }

  if (!data || data.total_records === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-400">
        No sustainability data available
      </div>
    );
  }

  const chartData = [
    { name: 'Zero Waste', value: data.zero_waste_score || 0 },
    { name: 'Carbon Offset', value: Math.min(data.carbon_footprint || 0, 100) },
    { name: 'Water Efficiency', value: Math.max(0, 100 - (data.water_usage || 0) / 10) },
  ];

  const COLORS = ['#10b981', '#3b82f6', '#8b5cf6'];

  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={2}
          dataKey="value"
          label={({ name, value }) => `${name}: ${Math.round(value)}%`}
          labelLine={{ stroke: '#374151' }}
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: 'rgba(17, 24, 39, 0.9)',
            border: '1px solid #374151',
            borderRadius: '8px',
            color: '#fff',
          }}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default SustainabilityGauge;
